import { httpGet, httpPost, HttpEvent, HttpEventCallbacks } from "@/events/eventsDomain";
import { CompanyInfo } from "@/types/CompanyInfo";

export type CompanyApiClient = {
  fetchCompanyInfo: (
    company: string,
    params: HttpEventCallbacks<CompanyInfo>,
  ) => HttpEvent<CompanyInfo>;
  updateRemark: (
    orgNo: string,
    remark: string | undefined,
    params: HttpEventCallbacks<void>,
  ) => HttpEvent<void>;
};

export const companyApiClient: CompanyApiClient = {
  fetchCompanyInfo: (company, params) => httpGet({ url: `/company/${company}`, ...params }),
  updateRemark: (orgNo, remark, params) =>
    httpPost({ url: `/company/${orgNo}/remark`, data: { remark }, ...params }),
};
